import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { sort_by_event } from 'gtm/pushEvents'

let SortableListMenu = (props) => {
  let renderLabel = (option) => {
    if (option === 'az') {
      return (
        <span>
          A <i className='fa fa-long-arrow-right' /> Z
        </span>
      )
    } else {
      return <span>{props.optionTitles[option]}</span>
    }
  }

  let sortableOptions = props.sortableFields.map((option, index) => {
    let sortableListItemClass = classNames('SortableList__listLabel', {
      selected: option === props.currOrder
    })

    return (
      <li key={index} id={index}>
        <a
          className={sortableListItemClass}
          href={`#${index}`}
          onClick={(e) => {
            e.preventDefault()
            sort_by_event(props.sortLocation, option)
            props.setOrder(option)
          }}
        >
          {renderLabel(option)}
        </a>
      </li>
    )
  })

  return (
    <div className='SortableList__popupMenu'>
      <ul>{sortableOptions}</ul>
    </div>
  )
}

SortableListMenu.defaultProps = {
  sortableFields: []
}

SortableListMenu.propTypes = {
  currOrder: PropTypes.string,
  optionTitles: PropTypes.object,
  setOrder: PropTypes.func,
  sortableFields: PropTypes.array,
  sortLocation: PropTypes.string
}

export default SortableListMenu
